module.exports = __webpack_public_path__ + "img/xmasParty19.2473b85d.jpg";